export default __webpack_public_path__ + "static/gray_pin-cdcc8e693629db9434613269fb4de990.png";